export default __webpack_public_path__ + "static/media/vegetarian.a3543515.svg";